import React from 'react';
import {Box, Container, Grid} from '@material-ui/core';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import {MetaTags} from 'react-meta-tags';
import {API_URL} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import Cookies from 'js-cookie';
// import { useDispatch } from 'react-redux';
// import { addUser } from '../store/user.actions';
// import { selectCourse } from '../store/course.actions';
// import { setMyCourses } from '../store/mycourses.actions';
// import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';

  export default function Execute() {
	//const isloggedin = Cookies.get('isloggedin');

	const authResult = new URLSearchParams(window.location.search); 
	const token = authResult.get('token');
	const loginId = authResult.get('loginId');
	const studentId = authResult.get('studentId');
	const mobile = authResult.get('mobile');
	const redirectTo = authResult.get('redirectTo');
	const deviceType = authResult.get('device_type');

	///console.log("token >> " + token);
	///console.log("redirectTo >> " + redirectTo);

	// if(isloggedin){
	//  	window.location.href='dashboard';
	// }

	React.useEffect(() => {
		login();	
	}, []); 


	function login(){
		///alert('Login Now');
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  
			//const accountDetails = Cookies.get("accountDetails");
			const data = new FormData();
			data.append('token', token);
			data.append('loginId', loginId);
			data.append('studentId', studentId);
			data.append('mobile', mobile);
			data.append('device', 'web');
			axios.post(API_URL+'/app/login', data, axiosHeader)
			.then((response) => {
				//console.log("RESPONSE RECEIVED: ", response);
				if(response && response.data && response.data.responseTxt==="success"){	
					// Set cookie accountDetails to login on website
					if(response.data.obj.courses && response.data.obj.courses.length>0){
						Cookies.set("accountDetails", JSON.stringify({
							sid: response?.data?.obj?.studentId,
							studentId: response?.data?.obj?.studentId,
							loginId: response?.data?.obj?.loginId,
							token: response?.data?.obj?.token,
							studentName: response?.data?.obj?.studentName,
							mobile: response?.data?.obj?.phoneNo,
							email: response?.data?.obj?.emailId
						}))
					}

					// Set cookie token for the use on website
					Cookies.set("token", response?.data?.obj?.token);

					localStorage.setItem("etlStudentObj", JSON.stringify(response.data.obj));
					localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj.courses));
					
					if(response.data.obj.openedCourse!=null && response.data.obj.openedCourse>0){
						localStorage.setItem("etlSelectCourse", response.data.obj.openedCourse);
					}else{
						localStorage.setItem("etlSelectCourse", 0);
					}

					if(deviceType && deviceType.length>0){
						localStorage.setItem("deviceType", deviceType);
					}else{
						localStorage.setItem("deviceType", 'android');
					}

					if(redirectTo && redirectTo.length>0){
						window.location.href = decodeURIComponent(redirectTo);
					}else{	
						window.location.href = "dashboard?ftu="+response.data.obj.firstTimeUser;
					}
					
				}else{
					window.location.href="login";
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})
		
	}
	

		return (
			<div> 
				<MetaTags>
            		<title>Login - Smart E-Learning Platform </title>
            		<meta name="description" content="Login" />
          		</MetaTags>
				
				<Container className="loginBGImg" style={{backgroundImage:"url('/student_login_bg.jpg')", backgroundPosition: 'center', height: '100vh', overflow: 'hidden'}}>					

				<Box>
						<Grid container style={{justifyContent: 'center'}} spacing={2}>
							<Grid item className="dhslogin" md={6} xs={12}>

							
								<Grid className="flex-container loginbox">								
									
									<h2 style={{color:'#FFF',marginTop:'16%'}}>
										Please wait...<br/>
										<CircularProgress style={{'color': 'yellow'}} />
									</h2>
								</Grid>
							

							</Grid>
											

						</Grid>
				</Box>




				</Container>
				
			</div>
		);
 
}